import axios from "axios";
import Swal from "sweetalert2";

export const getPos = async () => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/posterminals",
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

export const showPos = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/posterminals/${id}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postPos = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/posterminals", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updatePos = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/posterminals/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deletePos = async (id) => {
  const brear = localStorage.getItem("token");
  const lang = localStorage.getItem("i18nextLng");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم حذف نقطة البيع نهائياً",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "نعم، احذف",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/posterminals/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("تم الحذف!", `${data.message}`, "success");
      } else {
        Swal.fire("لم يتم الحذف", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
